'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m8.806 10.597-3.44 1.72a3 3 0 0 0-1.617 2.19l-.626 3.758a3 3 0 0 0 .113 1.442l.08.242A3 3 0 0 0 6.162 22h11.676a3 3 0 0 0 2.846-2.051l.08-.242a3 3 0 0 0 .114-1.442l-.627-3.758a3 3 0 0 0-1.617-2.19l-3.44-1.72" /><path stroke="currentColor" strokeWidth={2} d="M16 6.5c0 1.178-.041 2.42-.5 3.5-.724 1.703-2.148 2-3.5 2s-2.776-.297-3.5-2C8.041 8.92 8 7.678 8 6.5 8 3.462 9.79 2 12 2s4 1.462 4 4.5Z" /></svg>;
const IconUser = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconUser;